<template>
  <div class="MemberCenter">
    <el-tabs
      v-model="activeName"
      class="custom-tabs"
      @tab-click="handleClick"
      type="border-card"
    >
      <el-tab-pane label="已完成订单" name="first">
        <div class="order-filter">
          <el-input
            v-model="firstOrdernum"
            placeholder="请输入关键字查询"
            clearable
            style="width: 200px; margin-right: 10px"
            @keyup.enter.native="searchFirst"
          ></el-input>
          <el-date-picker
            v-model="payTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="付款开始时间"
            end-placeholder="付款结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            style="margin-right: 10px"
          ></el-date-picker>
          <el-button type="primary" @click="searchFirst">查询</el-button>
          <el-button @click="resetFirst">重置</el-button>
        </div>
        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="tableData"
          tooltip-effect="dark"
          element-loading-text="Loading"
          fit
          :default-sort="{ prop: 'date', order: 'descending' }"
        >
          <el-table-column label="序号" type="index" width="80" align="center">
          </el-table-column>
          <el-table-column
            prop="ordername_name"
            label="订单名"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="ordernum_name"
            label="订单号"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column prop="paymentstate_name" label="交易状态" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ getPaymentStateValue(scope.row.paymentstate_name) }}
                        </template>
</el-table-column> -->
          <el-table-column
            prop="tradeTime"
            label="支付时间"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column prop="purchasemethod_name" label="购买方式" align="center"
                        show-overflow-tooltip></el-table-column> -->
          <el-table-column
            prop="paymentamount_name"
            label="实付金额"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              ￥{{ scope.row.paymentamount_name }}
            </template>
          </el-table-column>
          <el-table-column
            prop="licensestatus"
            label="许可证状态"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ getLicenseStatus(scope.row.licensestatus) }}
            </template>
          </el-table-column>

          <el-table-column label="安装包下载" align="center">
            <template slot-scope="scope">
              <!-- <el-button type="text" v-if="getSoftType(scope.row.ordername_name, 'SummitMap')"
                                @click="toDownload('map')">SummitMap</el-button>
                            <el-button type="text" v-if="getSoftType(scope.row.ordername_name, 'SummitMap')"
                                @click="toDownload('environment')">环境包</el-button>
                            <el-button type="text" v-if="getSoftType(scope.row.ordername_name, 'SummitMapHUBEI')"
                                @click="toDownload('HUBEI')">SummitMapHUBEI</el-button>
                            <el-button type="text" v-if="getSoftType(scope.row.ordername_name, 'SummitSolid')"
                                @click="toDownload('solid')">SummitSolid</el-button>
                            <el-button type="text" v-if="getSoftType(scope.row.ordername_name, 'SummitLab')"
                                @click="toDownload('lab')">SummitLab</el-button>
                            <el-button type="text" v-if="getSoftType(scope.row.ordername_name, 'SummitSolidSGJ')"
                                @click="toDownload('solidSGJ')">SummitSolidSGJ</el-button> -->
              <el-button type="text" data-guide="orderDownload" @click="toDownloadAll(scope.row)"
                >下载</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="goDetail(scope.row.id)"
                >详情</el-button
              >
              <el-button
                type="text"
                v-if="scope.row.licensestatus == 0"
                @click="goLicense()"
                >许可证申请</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :total="total"
          :page.sync="listQuery.currentPage"
          :limit.sync="listQuery.pageSize"
          @current-change="handleCurrentChange"
          @pagination="getInit"
        />
      </el-tab-pane>
      <el-tab-pane label="待支付" name="second">
        <div class="order-filter">
          <el-input
            v-model="secondOrdernum"
            placeholder="请输入关键字查询"
            clearable
            style="width: 200px; margin-right: 10px"
            @keyup.enter.native="searchSecond"
          ></el-input>
          <el-date-picker
            v-model="createTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="创建开始时间"
            end-placeholder="创建结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            style="margin-right: 10px"
          ></el-date-picker>
          <el-button type="primary" @click="searchSecond">查询</el-button>
          <el-button @click="resetSecond">重置</el-button>
        </div>
        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="tableData"
          tooltip-effect="dark"
          element-loading-text="Loading"
          fit
          :default-sort="{ prop: 'date', order: 'descending' }"
        >
          <el-table-column label="序号" type="index" width="80" align="center">
          </el-table-column>
          <el-table-column
            prop="ordername_name"
            label="订单名"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="ordernum_name"
            label="订单号"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="creatortime"
            label="创建时间"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column prop="paymentstate_name" label="交易状态" align="center" show-overflow-tooltip>

                        <template slot-scope="scope">
                            {{ getPaymentStateValue(scope.row.paymentstate_name) }}
                        </template>
                    </el-table-column> -->
          <!-- <el-table-column prop="purchasemethod_name" label="购买方式" align="center"
                        show-overflow-tooltip></el-table-column> -->
          <el-table-column
            prop="paymentamount_name"
            label="待付款"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="goDetail(scope.row.id)"
                >详情</el-button
              >
              <el-button
                type="text"
                style="color: #f56c6c"
                @click="deletePendingOrder(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :total="totalSecond"
          :page.sync="listQuery.currentPage"
          :limit.sync="listQuery.pageSize"
          @current-change="handleCurrentChange"
          @pagination="getInit"
        />
      </el-tab-pane>
      <!-- <el-tab-pane label="待续费" name="third">待续费</el-tab-pane> -->
      <!-- <el-tab-pane label="物流状态" name="four">物流状态</el-tab-pane> -->
      <!-- <el-tab-pane label="许可申请状态" name="five">许可申请状态</el-tab-pane> -->
    </el-tabs>
    <OrderDetail
      ref="OrderDetail"
      v-if="detailVisible"
      @refresh="detailVisible = false"
    ></OrderDetail>
    <el-dialog
      title="下载"
      :close-on-click-modal="false"
      lock-scroll
      width="1000px"
      :visible.sync="downloadVisible"
    >
      <div class="downloadList">
        <el-table
          ref="downDataTable"
          :data="downData"
          tooltip-effect="dark"
          element-loading-text="Loading"
        >
          <el-table-column label="序号" type="index" width="80" align="center">
          </el-table-column>
          <el-table-column
            prop="productName"
            label="软件名称"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="productVersionTypeCn"
            label="软件版本"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="downloadSoft1(scope.row)"
                >下载安装包</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OrderDetail from "./OrderDetail.vue";
import request from "@/utils/request";
import { mapState, mapMutations } from "vuex";
import { getDownDataByOrderld } from "@/assets/API/pay";
import { getAfterPayPhase, startAfterPayGuideOrder } from "@/utils/guideTour";
export default {
  components: {
    OrderDetail,
  },
  data() {
    return {
      activeName: "first",
      tableData: [],
      loading: false,
      total: 0,
      totalSecond: 0,
      query: {
        userid: "", // 用户id
        paymentstate: "1", //（0-未支付，1-已支付，2-支付失败）
        purchasemethod: "online",
        menuId: "491144407886626501",
      },
      listQuery: {
        dataType: 0,
        superQueryJson: "",
        currentPage: 1,
        pageSize: 10,
        sort: "desc",
        sidx: "",
      },
      paymentStateList: [
        {
          value: "0",
          label: "未支付",
        },
        {
          value: "1",
          label: "已支付",
        },
        {
          value: "2",
          label: "支付失败",
        },
      ],
      orderCount: "",
      detailVisible: false,
      downloadVisible: false,
      downData: [],
      // 已完成订单：订单号 + 付款时间范围
      firstOrdernum: "",
      payTimeRange: [],
      // 待支付订单：订单号 + 创建时间范围
      secondOrdernum: "",
      createTimeRange: [],
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
  },
  mounted() {
    // F5 刷新时 vuex userInfo 尚未从接口恢复，先尝试用已有值；未就绪时由下方 watch 补发请求
    if (this.userInfo && this.userInfo.id) {
      this.query.userid = this.userInfo.id;
      this.getInit();
    }
    // 购买后引导 PHASE 1：等订单表格渲染后高亮「下载」按钮
    this.maybeStartOrderGuide();
  },
  watch: {
    // F5 刷新后 userInfo 异步恢复，就绪后补发一次订单请求（避免 loading 卡住）
    userInfo: {
      handler(val) {
        if (val && val.id && !this.query.userid) {
          this.query.userid = val.id;
          this.getInit();
        }
      },
      deep: true,
    },
  },
  methods: {
    getdownData(orderId) {
      getDownDataByOrderld(orderId).then((res) => {
        if (res.code == 200) {
          this.downData = res.data;
        }
      });
    },
    // 数据初始化
    // 购买后引导 PHASE 1：轮询等待「下载」按钮渲染后启动高亮引导
    maybeStartOrderGuide() {
      if (getAfterPayPhase() !== 1) return;
      let tries = 0;
      const tryStart = () => {
        const el = document.querySelector('[data-guide="orderDownload"]');
        if (el) {
          // 引导"下一步"：设 PHASE=2 并通知父组件启动「许可证申请」tab 引导
          startAfterPayGuideOrder(() => {
            this.$emit("orderGuideNext");
          });
        } else if (++tries < 40) {
          setTimeout(tryStart, 200);
        } else {
          // 超时放弃（可能无订单数据）
          import("@/utils/guideTour").then((m) => m.clearAfterPayGuide());
        }
      };
      setTimeout(tryStart, 300);
    },
    getInit() {
      this.loading = true;
      if (this.query.userid) {
        let _query = {
          ...this.listQuery,
          ...this.query,
        };
        let paymentstate = _query.paymentstate;
        request({
          url: `/api/business/C_customers/getOrderListWithStatus`,
          method: "post",
          data: _query,
        }).then((res) => {
          if (res.code == 200) {
            this.loading = false;
            this.tableData = res.data.list;
            if (paymentstate == "1") {
              this.total = res.data.pagination.total;
              this.orderCount = res.data.list.length;
              // this.orderCountLabel = "已完成订单(" + this.total + ")";
            } else {
              this.totalSecond = res.data.pagination.total;
            }
          }
        });
      }
    },
    getLicenseStatus(val) {
      if (val == 0 || val == 2) {
        return "未创建";
      } else if (val == 1) {
        return "已创建";
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.listQuery.currentPage = val;
      this.getInit();
    },
    getPaymentStateValue(val) {
      let res = this.paymentStateList.find(function (e) {
        return e.value == val;
      });
      return res.label;
    },
    goDetail(id) {
      this.detailVisible = true;
      this.$nextTick(() => {
        this.$refs.OrderDetail.init(id);
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
      console.log("tab.name", tab.name);
      this.tableData = [];
      // 切换tab时清空另一个tab的筛选条件，避免互相干扰
      delete this.query.keyword;
      delete this.query.paySt;
      delete this.query.payEt;
      delete this.query.starttime;
      delete this.query.endtime;
      if (tab.name == "first") {
        this.query.paymentstate = "1";
        this.secondOrdernum = "";
        this.createTimeRange = [];
      } else if (tab.name == "second") {
        this.query.paymentstate = "0";
        this.firstOrdernum = "";
        this.payTimeRange = [];
      }
      this.listQuery.currentPage = 1;
      this.listQuery.pageSize = 10;
      this.getInit();
    },

    // 已完成订单：订单号 + 付款时间范围查询
    searchFirst() {
      this.query.keyword = this.firstOrdernum;
      if (Array.isArray(this.payTimeRange) && this.payTimeRange.length === 2) {
        this.query.paySt = this.payTimeRange[0];
        this.query.payEt = this.payTimeRange[1];
      } else {
        delete this.query.paySt;
        delete this.query.payEt;
      }
      this.listQuery.currentPage = 1;
      this.getInit();
    },
    resetFirst() {
      this.firstOrdernum = "";
      this.payTimeRange = [];
      delete this.query.keyword;
      delete this.query.paySt;
      delete this.query.payEt;
      this.listQuery.currentPage = 1;
      this.getInit();
    },
    // 待支付订单：订单号 + 创建时间范围查询
    searchSecond() {
      this.query.keyword = this.secondOrdernum;
      if (
        Array.isArray(this.createTimeRange) &&
        this.createTimeRange.length === 2
      ) {
        this.query.starttime = this.createTimeRange[0];
        this.query.endtime = this.createTimeRange[1];
      } else {
        delete this.query.starttime;
        delete this.query.endtime;
      }
      this.listQuery.currentPage = 1;
      this.getInit();
    },
    resetSecond() {
      this.secondOrdernum = "";
      this.createTimeRange = [];
      delete this.query.keyword;
      delete this.query.starttime;
      delete this.query.endtime;
      this.listQuery.currentPage = 1;
      this.getInit();
    },
    goLicense() {
      this.$emit("toApply", true);
    },
    toDownloadAll(data) {
      this.downloadVisible = true;
      this.getdownData(data.id);
    },
    deletePendingOrder(row) {
      if (!row || !row.id) return;
      this.$confirm("确认删除该待支付订单吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return request({
            url: `/api/business/C_orderManage/${row.id}`,
            method: "DELETE",
          });
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功");
            if (this.tableData.length === 1 && this.listQuery.currentPage > 1) {
              this.listQuery.currentPage -= 1;
            }
            this.getInit();
          } else {
            this.$message.error(res.msg || "删除失败");
          }
        })
        .catch((err) => {
          if (err === "cancel") return;
          this.$message.error("删除失败");
        });
    },
    downloadSoft1(val) {
      if (val.downUrl == null || val.downUrl == "") {
        this.$message.error("暂无下载链接,请联系管理员");
        return;
      }
      const url = val.downUrl + "&pwd=" + val.extCode;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.MemberCenter {
  height: calc(100vh - 60px);
  // padding-left: 35px;
  // padding-right: 32px;

  ::v-deep .el-tabs {
    height: calc(100% - 100px);
  }

  :deep .el-tabs__header {
    padding-top: 15px;
    // margin: 0 0 35px
  }

  ::v-deep .el-tabs__content {
    height: calc(100% - 90px);
  }

  ::v-deep .el-tab-pane {
    height: calc(100% - 50px);
    display: flex;
    flex-direction: column;
  }

  ::v-deep .el-tabs--border-card {
    border: none;
    box-shadow: none;
  }

  ::v-deep .el-pagination {
    flex: 0 0 auto;
  }

  // :deep .el-tabs__active-bar {
  //     border-radius: 8px;
  //     background-color: rgb(123, 177, 238);
  // }

  // :deep .el-tabs__item {
  //     font-size: 16px;
  //     color: rgba(128, 128, 128, 0.9);
  // }

  // :deep .el-tabs__item.is-active {
  //     color: rgba(42, 130, 228, 1);
  // }

  // :deep .el-tabs__nav-wrap::after {
  //     display: none;
  // }

  // // table
  ::v-deep .el-table {
    // height: calc(100% - 125px) !important;
    flex: 1;
    min-height: 0;
  }

  :deep .el-table__header .has-gutter tr th {
    background-color: rgba(213, 231, 250, 1);
    border-right: 1px solid #fff;
    color: rgba(56, 56, 56, 1);
  }

  // :deep .el-table th.el-table__cell {
  //     background-color: rgba(245, 245, 245, 1);
  //     border-radius: 20px;
  //     border: none;
  // }

  // :deep .el-table__body tr:hover>td {
  //     background-color: rgba(245, 245, 245, 1) !important;
  // }

  // :deep .el-table tr {
  //     height: 46px;
  // }

  :deep .el-table__body-wrapper {
    height: calc(100% - 100px);
    overflow-y: auto;
  }

  // :deep .el-table__empty-block {
  //     min-height: 50px;
  // }

  // :deep .el-table th.el-table__cell>.cell {
  //     font-size: 14px;
  //     font-weight: 400;
  //     line-height: 22.4px;
  //     color: rgba(128, 128, 128, 0.7);
  // }

  // ::v-deep .el-pagination {
  //     padding-top: 20px;
  // }
}

.downloadList {
  text-align: center;
}

.order-filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 15px;
  flex: 0 0 auto;
}
</style>
<style lang="scss" scoped>
.custom-tabs .el-tabs__item {
  position: relative;
  padding: 0 20px;
  /* 调整内边距以适应梯形形状 */
  background-color: #ffffff;
  /* 标签背景色 */
  /* margin-right: 10px; */
  /* 调整标签之间的间距 */

  /* 使用 clip-path 创建梯形形状 */
  clip-path: polygon(5% 0%, 95% 0%, 100% 100%, 0% 100%);
}

.custom-tabs > .el-tabs__header .el-tabs__item.is-active {
  color: #fff !important;
}

.custom-tabs .is-active::before {
  content: attr(data-label);
  /* content: ''; */
  /* 使用伪元素显示标签文字 */
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #409eff;
  /* 梯形背景色 */
  transform-origin: top left;
  color: white;
  /* 文字颜色 */
  line-height: 40px;
  /* 根据具体高度调整 */
  text-align: center;
  z-index: -1;
  /* 确保文字在上层 */
}
</style>
